import * as jquery from '../../node_modules/jquery/dist/jquery.min';

/* global $ */

// Calculation for MainMenu to center the TG-brand-logo
jquery(function() {
    
  //return;
    // Extend menu-list if length is 'even' (including brand-logo)
    if ($('#nav-menu li').length%2 == 0) {
      $("#nav-menu").append('<li role="menuitem" class="nav-item link"><a href="/"></a></li>');
    }
    // Move brand-logo in the middle of menuitems - move the first-li-child as this is the #navbar-brand-item
    $('#nav-menu li').eq(0).insertAfter($('#nav-menu li').eq(Math.floor($('#nav-menu li').length/2)));        
    
    //shows the navbar and brand-logo
    setTimeout(() => { 
      $('loading').fadeOut();
      setTimeout(() => { $('#navbar').fadeIn(200); }, 0);
      setTimeout(() => { $('footer').fadeIn(200); }, 0);
      setTimeout(() => { $('main-header').fadeIn(200); }, 200);
      setTimeout(() => { $('main').fadeIn(200); }, 200);
      setTimeout(() => { $('#navbar-brand-item').fadeIn(500); }, 100);
    }, 100);

    const navbar = document.querySelector('#nav_container_sticky');
    const top = navbar.offsetTop + 20;
    function stickynavbar() {
      if (window.scrollY >= top) {    
        navbar.classList.add('sticky');
      } else {
        navbar.classList.remove('sticky');    
      }
    }
    window.addEventListener('scroll', stickynavbar);    
});